/*
 * Above 9 · Tranquitone · the "?" beside an add-on (original work, theme v0.2, 2026-10-04;
 * launch/CONVERSION_WAVE_v0.2.md 4: "a ? that opens two plain lines").
 *
 * A disclosure: the button's aria-expanded follows the panel, the panel is hidden until the button is pressed, and a
 * second press closes it. The button shows "?" and carries the copy's accessible name (ADD-Q-ARIA, "More about the
 * <item>"), a symbol label as WCAG 2.5.3's Understanding notes allow. It never ticks the box beside it: it sits
 * outside the box's label.
 */

class A9Help extends HTMLElement {
  connectedCallback() {
    this.button = /** @type {HTMLButtonElement | null} */ (this.querySelector('.a9-help__btn'));
    this.panel = /** @type {HTMLElement | null} */ (this.querySelector('.a9-help__panel'));
    if (!this.button || !this.panel) return;
    this.onClick = (/** @type {MouseEvent} */ event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!this.button || !this.panel) return;
      const open = this.button.getAttribute('aria-expanded') === 'true';
      this.button.setAttribute('aria-expanded', open ? 'false' : 'true');
      this.panel.hidden = open;
    };
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
  }
}

if (!customElements.get('a9-help')) customElements.define('a9-help', A9Help);
